exports.components = {
  "component---src-pages-jobs-index-js": () => import("./../../../src/pages/jobs/index.js" /* webpackChunkName: "component---src-pages-jobs-index-js" */),
  "component---src-templates-job-description-js": () => import("./../../../src/templates/job-description.js" /* webpackChunkName: "component---src-templates-job-description-js" */)
}

